export default [
  {
    path: "/sys",
    name: "sys",
    component: () => import('../components/sysinfo/sys.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/role",
    name: "role",
    component: () => import('../components/sysinfo/role.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/user",
    name: "user",
    component: () => import('../components/sysinfo/user.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/password",
    name: "password",
    component: () => import('../components/sysinfo/edit-password.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/default",
    name: "default",
    component: () => import('../components/sysinfo/default.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/clear",
    name: "clear",
    component: () => import('../components/sysinfo/clear.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/rolepower",
    name: "rolepower",
    component: () => import('../components/sysinfo/role-power.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/out",
    name: "out",
    component: () => import('../components/sysinfo/out.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/printset",
    name: "printset",
    component: () => import('../components/sysinfo/print-set.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/company",
    name: "company",
    component: () => import('../components/sysinfo/company.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/closeall",
    name: "closeall",
    component: () => import('../components/sysinfo/closeall.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/help",
    name: "help",
    component: () => import('../components/help.vue'),
    meta: { keepAlive: false }
  },
]



// WEBPACK FOOTER //
// ./src/router/sys-router.js